import React, { useEffect, useRef, useState } from 'react';

const RCRScholarships = () => {
  const [photos, setPhotos] = useState([]);
  const [file, setFile] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const fileInputRef = useRef();

  const CLOUD_NAME = 'dnybxda3y';
  const UPLOAD_PRESET = 'concert_photos';

  const fetchPhotos = () => {
    fetch('/api/scholarship-photos')
      .then(res => res.json())
      .then(data => setPhotos(data))
      .catch(err => console.error('Error fetching photos:', err));
  };

  useEffect(fetchPhotos, []);

  const handleFileClick = () => fileInputRef.current?.click();

  const handleFileSelect = (e) => setFile(e.target.files[0]);

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'rcr_scholarships');

    try {
      const uploadRes = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        { method: 'POST', body: formData }
      );

      const uploadData = await uploadRes.json();

      const transformedURL = uploadData.secure_url.replace(
        '/upload/',
        '/upload/w_500,c_fit,q_auto,f_auto/'
      );

      await fetch('/api/add-scholarship-photo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ImageURL: transformedURL })
      });

      setFile(null);
      fetchPhotos();
    } catch (err) {
      console.error('Error uploading:', err);
    }
  };

  const handleDelete = (id) => {
    fetch(`/api/delete-scholarship-photo/${id}`, { method: 'DELETE' })
      .then(() => {
        setSelectedPhoto(null);
        fetchPhotos();
      })
      .catch(err => console.error('Error deleting photo:', err));
  };

  return (
    <div className="section">
      <h2>RCR Scholarships</h2>

      <div className="concert-grid">
        {photos.map((photo, i) => (
          <img
            key={i}
            src={photo.ImageURL}
            alt={`Scholarship ${i + 1}`}
            className={`concert-photo ${localStorage.getItem('isAdmin') === 'true' ? 'admin-photo-hover' : ''}`}
            onClick={() => {
              if (localStorage.getItem('isAdmin') === 'true') {
                setSelectedPhoto(photo);
              }
            }}
            style={{
              cursor: localStorage.getItem('isAdmin') === 'true' ? 'pointer' : 'default'
            }}
          />
        ))}
      </div>

      {localStorage.getItem('isAdmin') === 'true' && (
        <div className="admin-upload-container">
          <span className="admin-upload-label">Upload Photo:</span>

          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />

          <button
            className={`admin-upload-button small ${file ? 'enabled' : ''}`}
            onClick={handleFileClick}
          >
            {file ? file.name : 'Choose File'}
          </button>

          <button
            className={`admin-upload-button small ${file ? 'enabled' : ''}`}
            onClick={handleUpload}
            disabled={!file}
          >
            Upload
          </button>
        </div>
      )}

      {selectedPhoto && (
        <div className="modal-overlay" onClick={() => setSelectedPhoto(null)}>
          <div
            className="record-card"
            style={{ width: '300px', textAlign: 'center', cursor: 'default' }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedPhoto.ImageURL}
              alt="Selected"
              style={{ width: '100%', marginBottom: '10px' }}
            />
            <button
              className="view-new-arrivals-button"
              onClick={() => handleDelete(selectedPhoto._id)}
            >
              Delete Photo
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RCRScholarships;
